import formatSegments from "../Helpers/formatSegments";
import formatPnlText from "../Helpers/formatPnl";
import { Popover } from "antd";

export default function PnlSummary({ data }) {

  const getEndPointOfUrl = (url) => {
    return url?.split("/")[url?.split("/").length - 1];
  };

  return (
    <div className="pnl-container p-3">
      <div className="summary-name-container d-flex">
        <div className="mr-2">
          <div className="profile-placeholder">
            <div className="w-100 h-100 d-flex align-items-center justify-content-center">
              {
                data?.custom_options?.ananymous ? (
                  data.first_name && data.first_name.slice(0, 1) ? (
                    data.first_name.slice(0, 1)
                  ) : (
                    "F"
                  )
                ) : data.profile_pic_link !== "" && data?.profile_pic_link &&
                getEndPointOfUrl(data.profile_pic_link) !== "NPP" ? (
                  <img className="profile-pic-img" src={data.profile_pic_link} alt="profile-pic" />
                ) : data.first_name && data.first_name.slice(0, 1) ? (
                  data.first_name.slice(0, 1)
                ) : (
                  "F"
                )
              }
            </div>
          </div>
        </div>
        <div>
          {
            data.custom_options.ananymous ? 
            <div className={`summary-user-name ${data.custom_options.ananymous ? "ananymous": ""}`}>
              {"FYERS User"}
            </div>
            :
            <div className="summary-user-name">
              {data.first_name ? data.first_name : "FYERS User"}
            </div>
          }
          <div className="summary-user-id">
            {data.client_id ? data.client_id : ""}
          </div>
        </div>
      </div>
      <hr />
      <div className="summary-user-segment-container">
        Segments:{" "}
        <span className="summary-user-segment">
          {data.segments ? formatSegments(data.segments) : "Unavailable"}
        </span>
      </div>
      <div className="summary-data-container mt-3 p-3">
        <div>
          <div className="d-flex flex-column">
            <span className="summary-data-heading">
              Total P&L{" "}
              <Popover
                overlayStyle={{
                  width: "216px",
                }}
                content={
                  <span className="total-pnl-popover-content">
                    It refers to the P&L, which excludes brokerage and other
                    charges.
                  </span>
                }
              >
                <img
                  src="https://assets.fyers.in/verified-pnl/images/icon-info.svg"
                  alt="Info"
                  width={14}
                />
              </Popover>
            </span>
            <span className="summary-totalpnl-value">
              {data.pnl_data.summary.total_pl
                ? formatPnlText.withColor(data.pnl_data.summary.total_pl)
                : "0"}
            </span>
          </div>
        </div>
        <hr className="summary-hr" />
        <div>
          <div className="d-flex flex-column">
            <span className="summary-data-heading">Realized P&L</span>
            <span className="summary-data-value">
              {data.pnl_data.summary.realized_pl
                ? formatPnlText.withColor(data.pnl_data.summary.realized_pl)
                : "0"}
            </span>
          </div>
        </div>{" "}
        <hr className="summary-hr" />
        <div>
          <div className="d-flex flex-column">
            <span className="summary-data-heading">Unrealized P&L</span>
            <span className="summary-data-value">
              {data.pnl_data.summary.unrealized_pl
                ? formatPnlText.withColor(data.pnl_data.summary.unrealized_pl)
                : "0"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}